import { profilePath, programPath } from "@travily/routes";
import type ProgramSearchHit from "@travily/types/pending/models/ProgramSearchHit";
import { MapPinCard, type MapPinCardAuthor } from "@/components/MapPinCard/MapPinCard";

export interface ProgramMapPinCardProps {
  hit: ProgramSearchHit;
  favorited?: boolean;
  onFavoriteToggle?: () => void;
  onClose: () => void;
  /** Full-bleed variant for the mobile map sheet (desktop popup stays 320px). */
  fullWidth?: boolean;
}

function resolveAuthor(account: ProgramSearchHit["account"]): MapPinCardAuthor | undefined {
  if (!account.handle) return undefined;
  return {
    avatar: account.avatar,
    href: profilePath(account.handle),
    initial: account.initial ?? "",
    name: account.display_name ?? account.handle,
    profile_type: account.profile_type ?? "Community",
  };
}

export function ProgramMapPinCard({ hit, favorited, onFavoriteToggle, onClose, fullWidth }: ProgramMapPinCardProps) {
  // Lead the carousel with the curated cover image so the popup matches the card/detail page.
  // `photos` can be absent on a pin backed by an aggregation `_source` that never loaded as a card.
  const photos = hit.photos ?? [];
  const images = hit.cover_image
    ? [hit.cover_image, ...photos.filter((photo) => photo.src !== hit.cover_image?.src)]
    : photos;

  return (
    <MapPinCard
      author={resolveAuthor(hit.account)}
      description={hit.tagline}
      favorited={favorited}
      href={programPath(hit.sqid)}
      image={images[0] ?? null}
      images={images.length > 1 ? images : undefined}
      imageSizes={fullWidth ? "100vw" : undefined}
      linkLabel={hit.name}
      onClose={onClose}
      onFavoriteToggle={onFavoriteToggle}
      title={hit.name}
      widthClassName={fullWidth ? "w-full" : undefined}
    />
  );
}
